import React from 'react';
const CHECKOUT_URL = 'https://checkout.tiendadigitalonline.com/cart/47950473298161:1';
export function SolutionSection() {
  return <section className="w-full bg-white py-16 md:py-20 px-4" data-id="element-314">
      <div className="max-w-3xl mx-auto text-center" data-id="element-315">
        <span className="inline-block bg-green-100 text-green-700 font-heading font-bold text-sm uppercase tracking-widest px-4 py-2 rounded-full mb-6" data-id="element-316">
          ✅ LA SOLUCIÓN
        </span>

        <h2 className="font-heading font-bold text-3xl md:text-5xl text-gray-900 leading-tight mb-6" data-id="element-317">
          ✨ Tarot y Autoconocimiento: curso completo desde cero
        </h2>

        <p className="font-body text-lg md:text-xl text-gray-700 leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-318">
          Un sistema claro, práctico y progresivo para que aprendas Tarot desde
          la base y lo uses como herramienta de crecimiento personal.
        </p>

        {/* 3-Step Flow */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-10" data-id="element-319">
          <div className="bg-gray-50 rounded-xl px-6 py-5 flex-1 max-w-xs" data-id="element-320">
            <span className="text-3xl mb-2 block" data-id="element-321">📂</span>
            <p className="font-heading font-bold text-lg text-gray-900" data-id="element-322">
              Abrís el ebook
            </p>
          </div>
          <span className="text-gold-500 text-3xl font-bold hidden md:block" data-id="element-323">
            →
          </span>
          <span className="text-gold-500 text-3xl font-bold md:hidden" data-id="element-324">↓</span>
          <div className="bg-gray-50 rounded-xl px-6 py-5 flex-1 max-w-xs" data-id="element-325">
            <span className="text-3xl mb-2 block" data-id="element-326">👀</span>
            <p className="font-heading font-bold text-lg text-gray-900" data-id="element-327">
              Entendés cada carta
            </p>
          </div>
          <span className="text-gold-500 text-3xl font-bold hidden md:block" data-id="element-328">
            →
          </span>
          <span className="text-gold-500 text-3xl font-bold md:hidden" data-id="element-329">↓</span>
          <div className="bg-gray-50 rounded-xl px-6 py-5 flex-1 max-w-xs" data-id="element-330">
            <span className="text-3xl mb-2 block" data-id="element-331">✍️</span>
            <p className="font-heading font-bold text-lg text-gray-900" data-id="element-332">
              Aplicás en tu vida
            </p>
          </div>
        </div>

        <p className="font-body text-lg md:text-xl text-gray-900 font-semibold" data-id="element-333">
          Sin frustración. Sin información confusa. Sin depender de otros.
        </p>

        {/* Extra CTA */}
        <div className="mt-10" data-id="element-334">
          <a href={CHECKOUT_URL} className="inline-block bg-gradient-to-r from-gold-500 to-gold-600 text-black font-heading font-bold text-lg md:text-xl px-8 py-4 rounded-lg animate-pulse-glow hover:from-gold-400 hover:to-gold-500 transition-all duration-300 uppercase tracking-wide" data-id="element-335">
            🔮 QUIERO TRANSFORMAR MI VIDA CON EL TAROT
          </a>
        </div>
      </div>
    </section>;
}